import React, { FC } from 'react';
import { buildUrlWithParameters } from '../../utils/url-utils/urlUtils';
import { NavDocumentAnalyzerText } from './NavDocumentAnalyzerText';
import styles from './nav_document_analyzer_link.module.scss';
import { NavItemLink } from '../components/item/NavItem';

export const NavDocumentAnalyzerLink: FC = () => (
  <NavItemLink
    className={styles.container}
    href={buildUrlWithParameters('/document-analyzer', {
      source: 'nav',
    })}
  >
    <NavDocumentAnalyzerText />
  </NavItemLink>
);
